/* eslint-disable max-len */
import { isEmpty } from "lodash";
import { grey } from "@mui/material/colors";
import {
  IAbsenceType,
  IEmployeeBalances,
} from "src/Pages/Company/Absences/AbsenceRecords/AbsenceRecords.models";

/**
 * Function transforming balances data from API to structure ready for rendering in two lists (active and inactive),
 * each containing absenceTypes and attendanceTypes. It adds badge color from group config to absence type,
 * moves secondary absence type to its parent `children` property and filters out data unnecessary for render.
 * @param {object} data - A collection of absence types available for given employee with their balance statuses.
 */
export default (data: IEmployeeBalances) => {
  if (!data || isEmpty(data))
    return {
      active: [],
      inactive: [],
    };

  const { balanceDetails, absenceGroupInfos } = data;

  const groupInfo = Object.fromEntries(
    absenceGroupInfos.map((group) => [group.id, { color: group.color }])
  );
  const entriesMap: { [key: string]: IAbsenceType } = {};
  const resultArray: IAbsenceType[] = [];

  balanceDetails.forEach((detail) => {
    const { absenceTypeInfo, status } = detail;

    const entry = {
      id: absenceTypeInfo.id,
      color: absenceTypeInfo.active
        ? groupInfo[absenceTypeInfo.absenceGroupId].color || "#C6D9BE"
        : grey[500],
      name: absenceTypeInfo.name,
      description: absenceTypeInfo.description,
      presenceType: absenceTypeInfo.presenceType,
      status,
      active: absenceTypeInfo.active,
      parentName: "",
    };

    entriesMap[absenceTypeInfo.id] = entry;

    // Only add to the result array if it has no parent (i.e., it's a top-level entry)
    if (!absenceTypeInfo.parentAbsenceTypeId) {
      resultArray.push(entry);
    } else {
      // Otherwise, add it as a child to its parent entry
      const parent = entriesMap[absenceTypeInfo.parentAbsenceTypeId];
      if (parent) {
        entry.parentName = parent.name;
        parent.absenceTypes = parent.absenceTypes || [];
        parent.absenceTypes.push(entry);
      }
    }
  });

  const active = resultArray.filter((type) => type.active);
  const inactive = resultArray.filter((type) => !type.active);

  return { active, inactive };
};
